module.exports = __webpack_public_path__ + "img/img_body_standard.973defd2.png";